import type { JSX, ReactNode } from 'react';
import { createContext, useMemo, useState } from 'react';
import React from 'react';

type TPrioritizeVerifiedActivity = boolean;

interface IReportContext {
  prioritizeVerifiedActivity: TPrioritizeVerifiedActivity;
  setPrioritizeVerifiedActivity: (value?: boolean) => void;
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
}

interface IReportProviderProps {
  readonly children: ReactNode;
  readonly value: TPrioritizeVerifiedActivity;
  readonly onChange?: (value?: boolean) => void;
}

export const ReportContext = createContext<IReportContext | undefined>(undefined);

const NOOP = (): void => {
  /* public report has no toggle — setter is intentionally inert */
};

export function ReportProvider({ children, value, onChange }: IReportProviderProps): JSX.Element {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const contextValue = useMemo(
    (): IReportContext => ({
      prioritizeVerifiedActivity: value,
      setPrioritizeVerifiedActivity: onChange ?? NOOP,
      isLoading,
      setIsLoading,
    }),
    [value, onChange, isLoading],
  );

  return <ReportContext.Provider value={contextValue}>{children}</ReportContext.Provider>;
}
